/* Vue application setup */

// Import dependencies
import Vue from 'vue';
import Axios from 'axios';
import Vuex from 'vuex';
import BootstrapVue from 'bootstrap-vue';

// Make Librar available throughout your project
Vue.use(BootstrapVue)
Vue.use(Vuex)

// Setup Vuex Store for Form Components
const store = new Vuex.Store({
  state: {
    results_count: 0,
    shown_count: 12,
    events_shown_count: 12,
    patient_videos_shown_count: 10,
    news_shown_count: 9,
    physicians_shown_count: 8,
    trials: '',
    counter: 0,
  },
  mutations: {
    incrementCount(state) {
      state.results_count++
    },
    resetCount(state){
      state.results_count = 0
    },
    resetPhysiciansCount(state){
      state.physicians_shown_count = 8
    },
    showMoreEvents(state){
      state.events_shown_count += 12
    },
    showMoreNews(state){
      state.news_shown_count += 9
    },
    resetNewsShownCount(state) {
      state.news_shown_count = 9;
    },
    resetTrialsShowCount(state){
      state.shown_count = 12
    },
    showMore(state){
      state.shown_count += 9
    },
    showMorePatientVideos(state){
      state.patient_videos_shown_count += 10
    },
    showMorePhysicians(state){
      state.physicians_shown_count += 8
    }
  }
})

// Store base URL for REST API Endpoint
Axios.defaults.baseURL = window.location.protocol + '//' + window.location.hostname + '/wp-json/wf/v1/';
Axios.defaults.headers.post['Content-Type'] = 'application/json';

// Import Components
import WFClincalSearch from './components/templates/wf-clinical-search-template.vue';
import WFClinicalForm from './components/wf-clinical-form.vue';

import Multiselect from 'vue-multiselect';

Vue.component('multiselect', Multiselect);

// Init Vue instances
createVueInstance(
    '#vue-wf-clinical-search',
    WFClincalSearch
);

createVueInstance(
  '#vue-wf-clinical-form',
  WFClinicalForm
)
 
// Creates a Vue instance for each element matching the selector
function createVueInstance(selector, component) {
    const elements = document.querySelectorAll(selector);
    elements.forEach(element => {
      new Vue({
        ...{ el: element, render: h=> h(component), store: store }
      });
    });
  }